export default __webpack_public_path__ + "8e3c95d4891e46aa2dc13c92dce7d28f.png";